import BadgeContainer from './BadgeContainer';
import { CampaignType, PlaybookType } from 'modules/Const';
import { PLAYBOOK_TYPE_INFO } from 'modules/Const';

interface BadgeCampaignTypeContainerProps {
    className?: string
    campaignType: PlaybookType | CampaignType
}

const BadgeCampaignTypeContainer = ({
    className,
    campaignType,
}: BadgeCampaignTypeContainerProps) => {
    const {
        title,
        icon,
    } = PLAYBOOK_TYPE_INFO[campaignType as PlaybookType]

    return (
        <BadgeContainer
            className={className}
            text={title}
            icon={icon}
        />
    )

}

export default BadgeCampaignTypeContainer;
